<template>
	<div class="section-content">
		<div class="page-title">
			<div style="padding-top:2%;">
				办案APP
				<img src="../assets/images/home_TitleLine.png" />
			</div>
		</div>

		<div class="content-section" style="height:84%;">
			<video :src="banAPPList.videoUrl" autoplay loop muted style="width: 100%;obiect-fit:cover;overflow: hidden;"></video>
		</div>
		
		<el-dialog
		 
		  :visible.sync="isShowPlay"
		  width="60%"
		  >
		  <video-player  class="video-player vjs-custom-skin" ref="videoUrl"
		  	style="width: 100%;border-radius: 4px;" :playsinline="true" :options="{
		  			  playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
		  			  autoplay: true, //如果true,浏览器准备好时开始回放。
		  			  controls: true, //控制条
		  			  preload: true, //视频预加载
		  			  muted: false, //默认情况下将会消除任何音频。
		  			  loop: false, //导致视频一结束就重新开始。
		  			  language: 'zh-CN',
		  			  aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（
		  			  fluid: true,
		  			  sources: [
		  			    {
		  			      type: 'video/mp4',
		  			      src: currentRow.videoUrl
		  			    }
		  			  ],
		  			  poster:currentRow.videoCoverImg,
		  			  notSupportedMessage: '此视频暂无法播放，请稍后再试'
		  			}"></video-player>
		</el-dialog>
		
	</div>

</template>

<script>
	import {
		honorList
	} from '@/api/webstation.js'

	export default {
		name: 'homeOne',
		components: {

		},
		data() {
			return {
				isShowPlay:false,
				banAPPList: [],
				currentRow:{}
			}
		},
		created() {
			this.gethonorList()

		},
		methods: {
			playVideo(data) {
				if(data.videoUrl)
				{
					this.currentRow = data
					this.isShowPlay = true
				}
				
			},
			gethonorList() {
				let that = this
				honorList({
					"pageNum": "1", //当前页
					"pageSize": "1", //每页展示的条数
					"showModel": '1'
				}).then(res => {
					if (res.code == 200) {
						that.banAPPList = res.rows[0]
						console.log('banAPPList: ',that.banAPPList);
						// that.detailInfo = res.rows[0]
					}
				})
			}
		},

	}
</script>

<style scoped>
	@import '../assets/home.css';

	.image-container {
		width: 32.5%;
		height: 100%;
		overflow: hidden;
	}

	.image-container .el-image {
		width: 100%;
		height: 100%;
		transition: transform 0.3s ease;
	}

	.image-container:hover .el-image {
		transform: scale(1.05);
	}
</style>


// WEBPACK FOOTER //
// src/components/home_three.vue